"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLivestreamStartDateProperty = exports.livestreamStartDatePropertyDefinition = void 0;
exports.livestreamStartDatePropertyDefinition = {
    view: { label: 'Start date' },
    constraints: [],
    type: 'date-time',
    multiple: false,
    name: 'livestream-start-date',
};
const isLivestreamStartDateProperty = (prop) => {
    return prop.name === exports.livestreamStartDatePropertyDefinition.name;
};
exports.isLivestreamStartDateProperty = isLivestreamStartDateProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGl2ZXN0cmVhbS1zdGFydC1kYXRlLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvbGl2ZXN0cmVhbS1zdGFydC1kYXRlLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEscUNBQXFDLEdBQUc7SUFDbkQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLFlBQVksRUFBRTtJQUM3QixXQUFXLEVBQUUsRUFBRTtJQUNmLElBQUksRUFBRSxXQUFXO0lBQ2pCLFFBQVEsRUFBRSxLQUFLO0lBQ2YsSUFBSSxFQUFFLHVCQUF1QjtDQUNFLENBQUE7QUFJMUIsTUFBTSw2QkFBNkIsR0FBRyxDQUFDLElBQWtCLEVBQXVDLEVBQUU7SUFDdkcsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLDZDQUFxQyxDQUFDLElBQUksQ0FBQTtBQUNqRSxDQUFDLENBQUE7QUFGWSxRQUFBLDZCQUE2QixpQ0FFekMifQ==